import React from 'react';
import { useNavigate } from 'react-router-dom';
import useAuthStore from '../store/authStore';

const UnauthorizedPage: React.FC = () => {
  const navigate = useNavigate();
  const { logout } = useAuthStore();
  
  const handleLogout = () => {
    logout();
    navigate('/login');
  };

  return (
    <div className="unauthorized-page">
      <div className="error-container">
        <h1>Access Denied</h1>
        <p>You don't have permission to access this page. This may happen if you don't have the required role or if feature flags are not correctly set up.</p>
        <div className="action-buttons">
          <button 
            className="button secondary-button" 
            onClick={() => navigate('/dashboard')}
          >
            Return to Dashboard
          </button>
          <button 
            className="button primary-button" 
            onClick={handleLogout}
          >
            Logout
          </button>
        </div>
      </div>
    </div>
  );
};

export default UnauthorizedPage; 